module.exports = __webpack_public_path__ + "img/levelup_icon_cross.4a433e07.svg";